import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import {
  FaLock,
  FaQrcode,
  FaCode,
  FaFileContract,
  FaShoppingCart,
  FaFingerprint,
  FaPalette,
  FaStopwatch,
  FaDice,
  FaSearch,
  FaIdCard,
  FaFileAlt,
  FaHashtag,
  FaGift,
  FaImage,
} from 'react-icons/fa'
import './ToolsPromo.css'
import Section from '../section/Section'
import { useScrollReveal } from '../../hooks/useScrollReveal'
import { useMagnetic } from '../../hooks/useMagnetic'
import { trackEvent } from '../../lib/analytics'

const HIGHLIGHT_POOL = [
  { icon: FaLock, label: 'Gerador de Senha' },
  { icon: FaQrcode, label: 'QR Code' },
  { icon: FaCode, label: 'Formatador JSON' },
  { icon: FaFileContract, label: 'Rescisão CLT' },
  { icon: FaShoppingCart, label: 'Lista de Compras' },
  { icon: FaFingerprint, label: 'Gerador de UUID' },
  { icon: FaPalette, label: 'Paleta de Cores' },
  { icon: FaStopwatch, label: 'Cronômetro Pomodoro' },
  { icon: FaDice, label: 'Sorteador de Números' },
  { icon: FaSearch, label: 'Testador de Regex' },
  { icon: FaIdCard, label: 'Gerador de CPF' },
  { icon: FaFileAlt, label: 'Gerador de Currículo' },
  { icon: FaHashtag, label: 'Gerador de Hash' },
  { icon: FaGift, label: 'Amigo Secreto' },
  { icon: FaImage, label: 'Compressor de Imagem' },
]

const pickRandom = (pool, count) => {
  const copy = [...pool]
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[copy[i], copy[j]] = [copy[j], copy[i]]
  }
  return copy.slice(0, count)
}

const ToolsPromo = () => {
  const revealRef = useScrollReveal({ y: 25, stagger: 0.08 })
  const ctaMagnetRef = useMagnetic({ strength: 0.3 })
  // A fresh random sample each time someone lands on the page, so repeat
  // visitors see a different slice of the catalog instead of the same six
  // tools forever.
  const highlights = useMemo(() => pickRandom(HIGHLIGHT_POOL, 6), [])

  return (
    <Section title="Ferramentas Gratuitas" stage="ferramentas">
      <div className="terminal-window" ref={revealRef}>
        <div className="terminal-bar">
          <span className="terminal-dot terminal-dot-red" />
          <span className="terminal-dot terminal-dot-yellow" />
          <span className="terminal-dot terminal-dot-green" />
          <span className="terminal-title">zsh  ferramentas</span>
        </div>
        <div className="terminal-body">
          <p className="terminal-line" data-reveal-item>
            <span className="terminal-prompt">$</span> ls ferramentas/{' '}
            <span className="terminal-muted">| shuf | head -6</span>
          </p>
          <ul className="tools-promo-highlights" data-reveal-item>
            {highlights.map(({ icon: Icon, label }) => (
              <li key={label}>
                <Icon aria-hidden="true" />
                <span>{label}</span>
              </li>
            ))}
          </ul>

          <p className="terminal-line" data-reveal-item>
            <span className="terminal-prompt">$</span> cat sobre.txt
          </p>
          <p className="terminal-output" data-reveal-item>
            Nas horas vagas eu também construí uma coleção de mais de{' '}
            <strong>50 ferramentas gratuitas</strong>: pequenos utilitários
            que resolvem problemas do dia a dia, de gerar uma senha forte até
            simular um financiamento. Tudo roda direto no seu navegador, sem
            cadastro.
          </p>

          <p className="terminal-line" data-reveal-item>
            <span className="terminal-prompt">$</span> open ferramentas/
            <span className="terminal-cursor" aria-hidden="true" />
          </p>
          <Link
            ref={ctaMagnetRef}
            to="/ferramentas"
            className="tools-promo-cta"
            data-reveal-item
            onClick={() =>
              trackEvent('tools_promo_click', { location: 'home_section' })
            }
          >
            Ver todas as ferramentas →
          </Link>
        </div>
      </div>
    </Section>
  )
}

export default ToolsPromo
